import { Modal } from '../modal';
import Body from './body';
import Footer from './footer';
import Header from './header';
import PopoverInternal from './popover-internal';
const PopoverNamespace = Object.assign(PopoverInternal, {
    Body,
    Button: Modal.Button,
    CloseButton: Modal.CloseButton,
    Footer,
    Header,
});
export default PopoverNamespace;
